import React from 'react';
import './RiskBadge.css';

/**
 * Risk Level Badge Component
 * Displays risk level for trend actionability
 * 
 * @param {Object} props
 * @param {string} props.riskLevel - Risk level: low|medium|high
 * @param {string} props.size - Size: small|medium|large (default: medium)
 * @param {boolean} props.showLabel - Whether to show text label (default: true)
 */

const RISK_CONFIG = {
  low: { emoji: '🟢', color: '#10B981', label: 'Low Risk' },
  medium: { emoji: '🟡', color: '#F59E0B', label: 'Medium Risk' },
  high: { emoji: '🔴', color: '#EF4444', label: 'High Risk' }
};

function RiskBadge({ riskLevel, size = 'medium', showLabel = true }) {
  const config = RISK_CONFIG[riskLevel] || RISK_CONFIG.medium;

  return (
    <div className={`risk-badge risk-badge-${size}`} style={{ color: config.color }}>
      <span className="risk-emoji">{config.emoji}</span>
      {showLabel && <span className="risk-label">{config.label}</span>}
    </div>
  );
}

export { RISK_CONFIG };
export default RiskBadge;
